import React, { Component } from "react";
import Card from "components/Card/Card.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import MUIDataTable from "mui-datatables";
import PropTypes from "prop-types";
import Add from "@material-ui/icons/Add";
import FormLabel from "@material-ui/core/FormLabel";

import Button from "components/CustomButtons/Button.jsx";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import Config from "../../config/";

import { pushLoader } from "actions/main";
import { pushMydata } from "actions/dashboard";

import { connect } from "react-redux";


import {
  pushUpload,
  pushUploadGlob,
  proccessUpload,
  fetchDataTable,
  pushUpdateStars,
  pushUpdateStarsGlob
} from "../../api/dashboard";

import withStyles from "@material-ui/core/styles/withStyles";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const ROOT_URL = Config.rooturl;
class ReferencesData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: "3",
      show: false,
      file_upload: "",
      file_title: "",
      msg: "",
      msg_file: "",
      datatable: [],
      ext: ""
    };
  }

  UNSAFE_componentWillMount() {
    fetchDataTable()
      .then(response => {
        this.setState({ datatable: response.data.results });
        this.props.pushMydata(response.data.results);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  UNSAFE_componentWillReceiveProps() {
    fetchDataTable()
      .then(response => {
        this.setState({ datatable: response.data.results });
        this.props.pushMydata(response.data.results);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  }

  changeRating(newRating) {
    this.setState({
      rating: newRating,
      open: false
    });
  }

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  snackbar() {
    return (
      <SnackbarContent
        message={"Warning - type your file name"}
        color="danger"
      />
    );
  }

  snackbarfile() {
    return (
      <SnackbarContent message={"Warning - choose your file"} color="danger" />
    );
  }

  handleUpload = () => {
    if (this.state.file_title == "") {
      this.setState({
        msg: this.snackbar()
      });
    } else if (this.state.file_upload == "") {
      this.setState({
        msg: ""
      });
      this.setState({
        msg_file: this.snackbarfile()
      });
    } else {
      this.props.pushLoader(true);
      this.setState({
        msg: ""
      });
      this.setState({
        msg_file: ""
      });

      proccessUpload(this.state.file_upload, this.state.ext)
        .then(response => {
          pushUpload(this.state.file_title, response.data.url)
            .then(() => {
              this.setState({ open: false });
              this.props.pushLoader(false);
            })
            .catch(error => {
              console.log(error);
              this.props.history.push("/pages/login#logout");
            });
          pushUploadGlob(this.state.file_title, response.data.url)
            .then(() => {
              this.setState({ open: false });
              this.props.pushLoader(false);
            })
            .catch(error => {
              console.log(error);
              this.props.history.push("/pages/login#logout");
            });
        })
        .catch(error => {
          console.log(error);
          this.props.history.push("/pages/login#logout");
        });
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleFileTitle = event => {
    this.setState({ file_title: event.target.value });
  };

  handleFileUpload = event => {
    const ext = event.target.files[0].name.split(".");
    this.setState({ file_upload: event.target.files[0], ext: ext[1] });
  };

  updateStars = (event, meta) => {
    this.props.pushLoader(true);
    pushUpdateStars(event, meta.rowData)
      .then(() => {
        this.props.pushLoader(false);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
    pushUpdateStarsGlob(event, meta.rowData)
      .then(() => {
        this.props.pushLoader(false);
      })
      .catch(error => {
        console.log(error);
        this.props.history.push("/pages/login#logout");
      });
  };

  render() {
    const { classes } = this.props;

    const columns = [
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "author",
        label: "Author",
        options: {
          filter: false
        }
      },
      {
        label: "File Name",
        name: "file_title",
        options: {
          filter: true
        }
      },
      {
        name: "downloaded",
        label: "Downloaded",
        options: {
          filter: false
        }
      },
      {
        name: "price",
        label: "Price",
        options: {
          filter: true,
          customBodyRender: value => {
            const nf = new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });

            return nf.format(value);
          }
        }
      },
      {
        name: "stars",
        label: "Rating",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <div>.</div>
            );
          }
        }
      },
      {
        name: "user_id",
        label: "user_id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "date_created",
        label: "date_created",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "dataseturl",
        label: "dataseturl",
        options: {
          filter: true,
          display: true,
          customBodyRender: (value, tableMeta) => {
            return <a href={ROOT_URL + value}>{value}</a>;
          }
        }
      }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "scroll"
    };

    return (
      <div>
        <div>
          <Button
            variant="outlined"
            color="default"
            onClick={this.handleClickOpen}
          >
            <Add /> Add My Data
          </Button>
          <Dialog
            open={this.state.open}
            onClose={this.handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="md"
            fullWidth={true}
          >
            <DialogTitle id="alert-dialog-title">{"Add Data"}</DialogTitle>
            <DialogContent>
              <form className={classes.form}>
                <GridContainer>
                  <GridItem xs={12} sm={2}>
                    <FormLabel className={classes.labelHorizontal}>
                      File Title
                    </FormLabel>
                  </GridItem>
                  <GridItem xs={12} sm={10}>
                    <CustomInput
                      id="help-text"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        type: "text",
                        onChange: this.handleFileTitle,
                        value: this.state.file_title
                      }}
                      helpText="name for your file."
                    />
                    {this.state.msg}
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={2} />
                  <GridItem xs={12} sm={10}>
                    <Button variant="contained" component="label">
                      <CustomInput
                        inputProps={{
                          type: "file",
                          onChange: this.handleFileUpload
                        }}
                      />
                    </Button>
                    {this.state.msg_file}
                  </GridItem>
                </GridContainer>
              </form>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose} color="primary">
                Cancel
              </Button>
              <Button onClick={this.handleUpload} color="primary" autoFocus>
                Add
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <MUIDataTable
                title={"My Data"}
                data={this.state.datatable}
                columns={columns}
                options={options}
              />
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

ReferencesData.propTypes = {
  classes: PropTypes.object.isRequired,
  pushLoader: PropTypes.string,
  pushMydata: PropTypes.object
};

function mapStateToProps(state) {
  return {
    token: state.token,
    blocking: state.loader
  };
}

export default (withStyles(regularFormsStyle)(
  connect(
    mapStateToProps,
    { pushLoader, pushMydata }
  )(ReferencesData)
));
